import {
  FETCH_DELETE_PROJECT_REQUEST,
  FETCH_DELETE_PROJECT_SUCCESS,
  FETCH_DELETE_PROJECT_FALUIRE,
} from './deleteProjectByProjectIDTypes'

const initialState = {
  loading: false,
  deleteProjectInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELETE_PROJECT_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_PROJECT_SUCCESS : return {
      ...state,
      deleteProjectInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_PROJECT_FALUIRE : return {
      ...state,
      loading: false,
      deleteProjectInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
